/* eslint-disable camelcase */
import React from 'react'
import style from './style.module.scss'

const Footer = () => {
  return (
    <div className={style.footer}>
      <div className={style.footerInner}>
        <span
          className={style.logo}
        >
          zero
          <span />
        </span>
        <br />
        <p className="mb-0">
          Copyright © {new Date().getFullYear()} zero 
          {/* |{' '}
          <a href="https://www.mediatec.org/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a> */}
        </p>
      </div>
    </div>
  )
}

export default Footer
